const bannerSetIsSelected = (selectedBannersets, uid) => Boolean(selectedBannersets.find(id => id === uid));

export default bannerSetIsSelected;
